/**
 * @author Indeform Ltd
 * @copyright Copyright 2018, Indeform Ltd
 * @version 20220830
 * @description Handles modal window basic functionality.
 */


 import Component from "../../core/component";


 class ModalWindow extends Component {
    get isMinimized() { return this._isMinimized; }

    set isMinimized(value) { return this._isMinimized = value; }

    constructor(ui, elmId, events, params = {}) {
        super(ui, elmId, events, params);

        this._isMinimized = false;
    }

    on_modalClose(data, e) {
        this.close();
    }

    on_modalSubmit(data, e) {
        this.close();
    }

    on_modalMinimize(data, e) {
        this.toggleMinimize();
    }

    open() {
        super.show({isVisible: true, isAnimated: true});
    }

    close() {
        super.show({isVisible: false, isAnimated: true});
    }

    toggleMinimize() {
        this.isMinimized = !this.isMinimized;
        this.elm.classList.toggle("anim-minimize", this.isMinimized);
    }
}

export { ModalWindow }
export default ModalWindow



//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/modules/modal-window/modal-window.js
// module id = 94
// module chunks = 0